import Get from "@/api/customer/job-profile/Get";

export const OPEN_FAN_KEY = 'job-profile-questionnaire';

const store = {
	namespaced: true,
	state: {
		show: false,
		jobProfile: undefined,
		onClose: undefined,
	},
	actions: {
		show ({commit}, data)
		{
			commit('layout/addOpenFan', OPEN_FAN_KEY, {root: true});

			commit('setJobProfile', data.jobProfile);
			commit('setOnClose', data.onClose);

			commit('setShow', true);
		},
		close ({commit, state})
		{
			if (state.onClose)
			{
				state.onClose({
					jobProfile: state.jobProfile
				});
			}

			commit('setShow', false);

			commit('setJobProfile', undefined);
			commit('setOnClose', undefined);

			commit('layout/removeOpenFan', OPEN_FAN_KEY, {root: true});
		},
		async reloadJobProfile ({state, commit})
		{
			const response = await new Get()
				.setJobProfileId(state.jobProfile.jobProfile.id)
				.call();

			commit('setJobProfile', response.data);
		}
	},
	mutations: {
		setShow: (state, value) => state.show = value,
		setJobProfile: (state, value) => state.jobProfile = value,
		setOnClose: (state, value) => state.onClose = value,
	},
};

export default store;
